export const BLOG_ARTICLES = '/platform/content/blog/articles';
export const BLOG_ARTICLES_SIMILAR = (slug) => `/platform/content/blog/${slug}/articles/similar`;
export const BLOG_ARTICLE = (slug) => `/platform/content/blog/article/${slug}`;
